import React, { useState, useEffect, useMemo } from 'react';
import apiClient from '../utils/apiClient';
import { useTable, usePagination, useGlobalFilter, useSortBy } from 'react-table';
import Swal from 'sweetalert2';
import Select from "react-select";
import { SERVER_BASE } from '../config/server';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faEdit, faTrash, faPlus, faPencil } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import { useNavigate } from "react-router-dom";
const LedgerMasterList = ({ permissions }) => {
  const [ledgers, setLedgers] = useState([]);
  const code = localStorage.getItem('code');
  const role = localStorage.getItem('role')
  const token = localStorage.getItem('token');

  const [profileDetails, setProfileDetails] = useState(null);
  const email = localStorage.getItem('email')
  const navigate = useNavigate(); // Initialize useNavigate
  const [loadingLedgerMaster, setLoadingLedgerMaster] = useState(true);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await Promise.all([fetchLedgerMasters(), fetchProfileDetails()]);
      } catch (err) {
        console.error("Initial data fetch failed", err);
      } finally {
        setLoadingLedgerMaster(false); // ✅ Hide spinner when both are done
      }
    };
    fetchInitialData();
  }, []);


  const fetchProfileDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email } });
      setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
    } catch (err) {
      console.error('Error fetching profile details:', err);
      setProfileDetails(null);

    }
  };
  const fetchLedgerMasters = async () => {
    try {
      const token = localStorage.getItem('token'); // Retrieve token from localStorage
      if (!token) {
        console.error('Unauthorized: No token found.');
        Swal.fire({
          icon: 'error',
          text: 'You need to log in to fetch ledger masters.',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
        return;
      }

      const response = await apiClient.get(SERVER_BASE + '/ledgerMastersList', {
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setLedgers(response.data); // Set the ledger data fetched from backend
    } catch (error) {
      console.error('Error fetching ledger masters:', error);
    }
  };

  const handleEdit = (row) => {
    navigate(`../addLedgerMaster`, { state: { row } });

  };
  const handleView = (row) => {
    navigate(`../addLedgerMaster`, { state: { row ,readOnly:1} });

  };

  const handleDelete = (index) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this ledger!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const token = localStorage.getItem('token'); // Retrieve token from localStorage

          if (!token) {
            Swal.fire({
              icon: 'error',
              text: 'Unauthorized: Please log in to proceed.',
              toast: true,
              position: 'top-end',
              timer: 3000,
              showConfirmButton: false,
            });
            return;
          }

          // Call the backend delete route with Authorization header
          const response = await apiClient.delete(
            `${SERVER_BASE}/deleteLedgerMaster/${ledgers[index].id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`, // Include JWT token in the header
              },
            }
          );

          // Display the success message from the response
          Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: response.data.message || 'Ledger has been deleted successfully!',
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false,
          });

          // Remove the deleted ledger from the state
          const updatedLedgers = ledgers.filter((_, i) => i !== index);
          setLedgers(updatedLedgers);
        } catch (error) {
          console.error('Error deleting the ledger:', error);
        }
      }
    });
  };


  const columns = useMemo(
    () => [
      {
        Header: 'S.No',
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: 'Ledger Group',
        accessor: 'ledgerGroup',
      },
      { Header: 'Ledger Name', accessor: 'printName' },
      {
        Header: 'State',
        accessor: (row) => `${row.state ? `${row.state} (${row.stateCode}) ` : ''}`,
        id: 'state',
      },
      { Header: 'Center', accessor: 'centerType' },
      { Header: 'Area Jurisdiction', accessor: 'areaJurisdiction' },
      { Header: 'Status', accessor: 'status' },
      {
        Header: "#",
        accessor: "Action",
        Cell: ({ row }) => {
          const {
            createdAt,
            createdByName,
            updatedAt,
            updatedByName,
          } = row.original;
      
          return (
            <div className="d-flex align-items-center gap-1">
      
              {/* VIEW BUTTON */}
              {(role == "itManager" || permissions?.read) && (
                <button
                  className="btn btn-outline-success btn-sm"
                  onClick={() => handleView(row.original)}
                >
                  View
                </button>
              )}
      
              {/* DROPDOWN */}
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-light"
                  type="button"
                  id={`dropdownMenuButton-${row.index}`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>
      
                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby={`dropdownMenuButton-${row.index}`}
                >
                  {/* Edit */}
                  {(role === "itManager" || permissions?.edit) &&
                    row.original.status !== "Final" && (
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleEdit(row.original)}
                        >
                          <FontAwesomeIcon icon={faEdit} className="me-2" />
                          Edit
                        </button>
                      </li>
                    )}
      
                  {/* Delete */}
                  {(role === "itManager" || permissions?.delete) &&
                    row.original.status !== "Final" && (
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleDelete(row.index)}
                        >
                          <FontAwesomeIcon icon={faTrash} className="me-2" />
                          Delete
                        </button>
                      </li>
                    )}
      
                  {(createdByName || updatedByName) && (
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                  )}
      
                  {/* Created */}
                  {createdByName && (
                    <li className="dropdown-item text-muted">
                      <FontAwesomeIcon icon={faPlus} /> {createdByName}
                      {createdAt &&
                        ` (${moment(createdAt).format("DD-MMM-YY hh:mm A")})`}
                    </li>
                  )}
      
                  {/* Updated */}
                  {updatedByName && (
                    <li className="dropdown-item text-muted">
                      <FontAwesomeIcon icon={faPencil} /> {updatedByName}
                      {updatedAt &&
                        ` (${moment(updatedAt).format("DD-MMM-YY hh:mm A")})`}
                    </li>
                  )}
                </ul>
              </div>
            </div>
          );
        },
      }
      

    ],
    [ledgers,permissions]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
  } = useTable(
    { columns, data: ledgers, initialState: { pageIndex: 0, pageSize: 20 }, },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  if (loadingLedgerMaster) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '60vh' }}>
        <div className="spinner-border text-success" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-3 fs-5">Loading Ledger Masters...</div>
      </div>
    );
  }
  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Ledger Master</h3>
        <div className="ledger-count">
          Total Ledgers: <strong>{ledgers.length}</strong>
        </div>
      </div>
      <div className='formcontainer table-responsive'>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3">
          {/* Add Ledger Button */}
          {(permissions?.write || role == 'itManager')
            && <button
              className="btn btn-outline-success"
              onClick={() => navigate('../addLedgerMaster')}
            >
              Add Ledger
            </button>}

          {/* Search + Page Size */}
          {(permissions?.read || role == 'itManager') &&
            <div className="d-flex align-items-center gap-3 flex-grow-1">
              {/* Search Input */}
              <input
                type="text"
                className="form-control"
                placeholder="Search ledger"
                value={globalFilter || ''}
                onChange={(e) => setGlobalFilter(e.target.value)}
              />

              {/* Page Size Dropdown */}
              <label className="d-inline-flex align-items-center gap-2">
                <select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                  className="form-select w-auto"
                >
                  {[20, 30, 50, 100].map((size) => (
                    <option key={size} value={size}>
                      Show {size}
                    </option>
                  ))}
                </select>
              </label>
            </div>}
        </div>

        {(permissions?.read || role == 'itManager') &&
          <>
            <table {...getTableProps()} className="table table-striped" style={{ fontSize: '13px', verticalAlign: 'baseline' }}>
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                        {column.render('Header')}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => (
                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="pagination d-flex justify-content-between align-items-center">
              <button
                className="btn btn-secondary"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                Previous
              </button>
              <span>
                Page{' '}
                <strong>
                  {pageIndex + 1} of {pageOptions.length}
                </strong>
              </span>
              <button
                className="btn btn-secondary"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                Next
              </button>
            </div>
          </>}
      </div>
    </div>
  );
};

export default LedgerMasterList;
